define('responsive-gameday/views/Monitor/ViewModels/PlaysViewModel',['require','exports','module','./ViewModelBase','GameDayCore/GDModel/enums/datasources/Datasources','gameday-index-enums/enums/baseball/GameStates','./distributors/ChyronDistributor','./distributors/FieldViewDistributor','./distributors/MatchupViewDistributor','./distributors/PitchByPitchViewDistributor','./distributors/PitchFXViewDistributor','./distributors/PlayByPlayViewDistributor','../Events/ViewModelUpdateEvents','message-service/message-service','../../../utils/ui-log','./distributors/VideoContentDistributor','./distributors/VideoAdvertisingDistributor'],function(require,exports,module) {
    var ViewModelBase = require("./ViewModelBase"),
        Datasources = require("GameDayCore/GDModel/enums/datasources/Datasources"),
        GameStates = require("gameday-index-enums/enums/baseball/GameStates"),
        ChyronDist = require("./distributors/ChyronDistributor"),
        FieldDist = require("./distributors/FieldViewDistributor"),
        MatchupDist = require("./distributors/MatchupViewDistributor"),
        PitchByPitchDist = require("./distributors/PitchByPitchViewDistributor"),
        PitchFXDist = require("./distributors/PitchFXViewDistributor"),
        PlayByPlayDist = require("./distributors/PlayByPlayViewDistributor"),
        // ScoringPlaysDist = require("./distributors/ScoringPlaysViewDistributor"),
        UpdateEvents = require("../Events/ViewModelUpdateEvents"),
        MessageService = require("message-service/message-service"),
        uilog = require( '../../../utils/ui-log' ),
        VideoContentDist = require("./distributors/VideoContentDistributor"),
		videoAdsDist = require("./distributors/VideoAdvertisingDistributor");
        
    var Superclass;

    function PlaysViewModel() {
        Superclass.constructor.call(this);
        this.playByPlayDist = new PlayByPlayDist(UpdateEvents.UPDATE_PLAYBYPLAY);
        // this.scoringPlaysDist = new PlayByPlayDist(UpdateEvents.UPDATE_SCORES);
    }

    ViewModelBase.spawn(PlaysViewModel).define({
        moldData: function(flavor) {
            uilog.info('plays view model',flavor);
            ChyronDist.setGameData(this.gameData, this.stateUpdates);
            FieldDist.setGameData(this.gameData, this.stateUpdates);
            MatchupDist.setGameData(this.gameData, this.stateUpdates);
            PitchByPitchDist.setGameData(this.gameData, this.stateUpdates);
            PitchFXDist.setGameData(this.gameData, this.stateUpdates);
            VideoContentDist.setGameData(this.gameData, this.stateUpdates);
			videoAdsDist.setGameData(this.gameData, this.stateUpdates);
            this.playByPlayDist.refresh(this.gameData);
        }
    });

    Superclass = PlaysViewModel.superclass;
    return PlaysViewModel;
});
